module.exports = __webpack_public_path__ + "img/settings_outlined_64.5ca885f7.svg";